// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".News-cls1__c9a00b42e040f9144329{/*!*/}.News-cls2___04c9e1f887e156df05e{background:#f8f8fb;color:#535366;padding:0 4px 0;margin-top:4px;border-radius:4px;height:22px;white-space:nowrap}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"cls1": "News-cls1__c9a00b42e040f9144329",
	"cls2": "News-cls2___04c9e1f887e156df05e News-cls1__c9a00b42e040f9144329"
};
export default ___CSS_LOADER_EXPORT___;
